import React from 'react'
import { Link } from 'react-router-dom'
import Head from '../../components/Head'

export default (props) => (
  <div>
    <Head {...props} />
    <div className="containerWrapper">
    <div className="containerWrapper" style={{backgroundColor:"white"}}>
      <h2><b>API Documentation</b></h2>
      <p style={{fontSize:"15px"}}>
        This documentation provides a step by step guide on how to use our API that is built on REST protocol, uses OAuth for authentication and returns data in a default JSON format.
      </p>
      <br/><br/>
      <div style={{paddingLeft:"25px"}}>
        <h4><b>Overview</b></h4>
        <p>
          Asian Hospital and Medical Center’s official API is a cloud based application that allows users to fetch data to enable integration with their other systems. The API is solely built upon the AWS services.
        </p>
        <br/>
        <h4><b>Setup your Account</b></h4>
        <p>
          A registered account is required to utilize hopprLabs API, please be sure to register before you get started.
        </p>
        <br/>
        <h4><b>Subscribe</b></h4>
        <p>
          Once an account is setup, subscribe to the API that you wish to utilize. API subscription is a vital step, failure to do so will result to a "forbidden" request. You may also opt to unsubscribe anytime.
        </p>
        <br/>
        <h4><b>Authentication & Authorization</b></h4>
        <p>
          <a href="https://oauth.net/" target="_blank">Oauth</a> is the main authorization framework used for hopprLabs API. To know and read more about Oauth, please refer to <a href="https://tools.ietf.org/html/rfc6749" target="_blank">RFC 6749</a>.
        </p>
        <br/><br/>
        <div style={{paddingLeft:"25px"}}>
          <h5><b>Access Token</b></h5>
          <p>
            An access token is the credential that can be used to access an API. It is unique to a user and should be stored securely and should be included to every request sent to the server. To retrieve the token, please refer to the instructions below.
          </p>
          <br/>
          <p style={{paddingLeft:"15px"}}>
            Send a POST request to the token endpoint, <mark>https://apiauth.hopprlab.com/oauth2/token.</mark>
            <br/><br/>
            <span>The following request parameters should be included in the Header:</span>
            <br/>
            <br/>
            <p style={{paddingLeft:"40px"}}>
              <span style={{fontStyle:"italic"}}>
                Content-Type: application/x-www-form-urlencoded<br/>
                Authorization: Basic secret_key
              </span>
            </p>
            <br/>
            <span>While the Body should be in an x-www-form-urlencoded format and should have the following request parameters:</span>
            <br/>
            <br/>
            <p style={{paddingLeft:"40px"}}>
              <span style={{fontStyle:"italic"}}>
                grant_type: client_credentials<br/>
                scope: api-auth/read
              </span>
            </p>
            <br/>
            <span>The token endpoint will respond with the following:</span>
            <br/>
            <br/>
            <p style={{paddingLeft:"40px"}}>
              <span style={{fontStyle:"italic"}}>
                access token - a Json Web Token, to know more about JWT please refer to this <a href="https://jwt.io/introduction" target="_blank">link</a>.<br/>
                expires_in - length of time in sconds that the token is valid.<br/>
                token_type - type of token (Bearer).
              </span>
            </p>
          </p>
        </div>
        <br/><br/>
        <h4><b>API Usage</b></h4>
        <p>
          The APIs endpoint base url is <mark>https://api.hopprlab.com.</mark>
          For each call made to the API, the token and API Key should be included in the Header.
          <br/><br/>
          <p style={{paddingLeft:"50px"}}>
            <span style={{fontStyle:"italic"}}>
              Authorization: Bearer access_token<br/>
              x-api-key: api_key
            </span>
          </p>
          <br/>
          Once the server verifies the users token and API Key, it will return a 200 status code together with the requested data.
        </p>
        <br/><br/>
        <div className="noteBox">
        <span><b>Note</b>: We will be providing the credentials that you will supply for the following fields, <i style={{fontStyle:"italic"}}>client_id</i> and <i style={{fontStyle:"italic"}}>client_secret</i> that are needed for Authorization.</span>
        </div>
      </div>
    </div>
    </div>
  </div>)



/** WEBPACK FOOTER **
 ** ./src/pages/Documentation/index.js
 **/